import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { getClassName } from '../utils/get-class-name';
var Container = styled.label.withConfig({
  displayName: "Label__Container"
})(["margin-right:auto;margin-left:0;cursor:", ";"], function (props) {
  return props.disabled ? 'text' : 'pointer';
});

var Label = function Label(_ref) {
  var className = _ref.className,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      labelText = _ref.labelText,
      sharedId = _ref.sharedId;
  return _jsx(Container, {
    className: getClassName(className, null, 'styled-label'),
    disabled: disabled,
    htmlFor: sharedId,
    children: labelText
  });
};

var LabelTest = {
  Container: Container
};
export { Label, LabelTest };
export default Label;